import { render } from "./LockedItems.vue?vue&type=template&id=29b9b880"
import script from "./LockedItems.vue?vue&type=script&lang=js"
export * from "./LockedItems.vue?vue&type=script&lang=js"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__